import { useMutation } from "@apollo/client";
import { CREATE_INTEGRATION_MUTATION } from "../../../apis/salesforce/queries";
import {
  CreateIntegrationResponse,
  CreateIntegrationVariables,
} from "../types";
import { HG_FORCE_CLIENT } from "../../../utils/consts";

export interface UseCreateIntegrationOptions {
  onCompleted?: (data: CreateIntegrationResponse) => void;
  onError?: (error: Error) => void;
}

export const useCreateIntegration = (
  options: UseCreateIntegrationOptions = {}
) => {
  const { onCompleted, onError } = options;

  const [createIntegrationMutation, result] = useMutation<
    CreateIntegrationResponse,
    CreateIntegrationVariables
  >(CREATE_INTEGRATION_MUTATION, {
    context: { clientName: HG_FORCE_CLIENT },
    onCompleted,
    onError,
    errorPolicy: "all",
  });

  const createIntegration = async (variables: CreateIntegrationVariables) => {
    try {
      const response = await createIntegrationMutation({ variables });
      return response.data?.createIntegration;
    } catch (error) {
      console.error("Error creating integration:", error);
      throw error;
    }
  };

  return {
    createIntegration,
    ...result,
    integration: result.data?.createIntegration,
  };
};
